import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendClientSpaceEmailReminder(ids: number[]) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.sendClientSpaceEmailReminder.url, null))
    .post({ ids })
}

export function sendClientSpacePhoneReminder(ids: number[]) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.sendClientSpacePhoneReminder.url, null))
    .post({ ids })
}
